module.exports = __webpack_public_path__ + "static/media/help.c6c8017e.svg";